/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Vue from 'vue'
import {
  CHECK,
  LOGIN,
  LOGOUT,
  GROUP_VIEW,
  CHECK_GROUP_VIEW,
} from './mutation-types'

export default {
  [CHECK](state) {
    const accessToken = localStorage.getItem('accessToken')
    state.authenticated = !!accessToken
    if (state.authenticated) {
      state.accessToken = accessToken
      Vue.$http.defaults.headers.common.Authorization = `token ${accessToken}`
    }
  },

  [LOGIN](state, token) {
    state.authenticated = true
    state.accessToken = token
    localStorage.setItem('accessToken', token)
    Vue.$http.defaults.headers.common.Authorization = `token ${token}`
  },

  [CHECK_GROUP_VIEW](state, group) {
    const viewAs = localStorage.getItem('viewAs')
    state.viewAs = viewAs ? +viewAs : null
  },

  [GROUP_VIEW](state, group) {
    state.viewAs = group
    if (group) {
      localStorage.setItem('viewAs', group)
    } else {
      localStorage.removeItem('viewAs')
    }
  },

  [LOGOUT](state) {
    state.authenticated = false
    state.accessToken = ''
    localStorage.removeItem('accessToken')
    localStorage.removeItem('viewAs')
    Vue.$http.defaults.headers.common.Authorization = ''
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js